import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";
import { DialogProps } from "@radix-ui/react-dialog";
import { useTranslation } from "react-i18next";

interface ConfirmDialogProps extends DialogProps {
  title: string;
  content: React.ReactNode;
  yesLabel?: string;
  noLabel?: string;
  onConfirm: () => void;
  variant?: "destructive";
}

export default function ConfirmDialog({
  children,
  title,
  content,
  yesLabel,
  noLabel,
  onConfirm,
  variant,
}: ConfirmDialogProps) {
  const { t } = useTranslation();
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent
        className={cn("w-4/5 max-w-xl", {
          "border-2 border-destructive text-red-800": variant === "destructive",
        })}
        onCloseAutoFocus={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <article className="py-2">{content}</article>
        <DialogFooter className="gap-3">
          <DialogClose asChild>
            <Button type="button" onClick={onConfirm} variant={variant}>
              {yesLabel ?? t("common.yes")}
            </Button>
          </DialogClose>
          <DialogClose asChild>
            <Button variant="secondary">{noLabel ?? t("common.no")}</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
